import * as React from 'react';

import styles from './legacy-setup-empty-state.module.css';

type Props = {
    text: string | React.ReactNode;
};

export function LegacySetupTableEmptyState(props: Props) {
    return <div className={styles['empty-state']}>{props.text}</div>;
}
